import { compose } from 'redux';
import { connect } from 'react-redux';
import onlyIf from '../../hocs/onlyIf';
import PanelColours from '../../components/handoff/PanelColours';
import { getDocumentColors } from '../../selectors/handoff';
function mapStateToProps(state) {
    return getDocumentColors(state);
}
export default compose(connect(mapStateToProps), onlyIf(function (props) { return props.opacityCols.length || props.solidCols.length; }))(PanelColours);
